import axios from '../axios';
import * as models from './models';

export function Images(hyejooRequestInit: models.IHyejooRequest): Promise<models.ImagesResponse> {
    return axios.get('/images', {
        params: new models.HyejooRequest(hyejooRequestInit),
    }).then(r => models.ImagesResponse.fromJSON(r.data));
}
